<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <filter-layout
    title="성별"
    sub-title="중복 선택이 가능합니다."
    :sub-title-style="{
      color: '#cccccc',
      'font-size': '1.2rem'
    }"
    padding-y="3rem"
    padding-x="3.2rem"
    width="29rem"
    class="gender-filter"
    v-show="isShow"
  >
    <ul class="gender-type-list">
      <li>
        <button class="gender-type-name" @click="filterUpdate(filterConstant.USE_SEX_TYPE.UNIVERSAL)" :class="{'on' : hasFilter(filterConstant.USE_SEX_TYPE.UNIVERSAL)}">남녀공용</button>
      </li>
      <li>
        <button class="gender-type-name" @click="filterUpdate(filterConstant.USE_SEX_TYPE.SEPARATE)" :class="{'on' : hasFilter(filterConstant.USE_SEX_TYPE.SEPARATE)}">남녀층분리</button>
      </li>
      <li>
        <button class="gender-type-name" @click="filterUpdate(filterConstant.USE_SEX_TYPE.WOMAN)" :class="{'on' : hasFilter(filterConstant.USE_SEX_TYPE.WOMAN)}">여성전용</button>
      </li>
      <li>
        <button class="gender-type-name" @click="filterUpdate(filterConstant.USE_SEX_TYPE.MAN)" :class="{'on' : hasFilter(filterConstant.USE_SEX_TYPE.MAN)}">남성전용</button>
      </li>
    </ul>
  </filter-layout>
</template>
<script>
  import FilterLayout from '../Layout/FilterLayout'
  import filterConstant from '../../const/filters'

  export default {
    name: 'GenderFilter',
    components: {FilterLayout},
    props: {
      isShow: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        filterConstant
      }
    },
    methods: {
      filterUpdate (useSexType) {
        this.$store.dispatch('setUseSexType', useSexType)
        console.log(this.$store.state.FILTERS.USE_SEX_TYPE)
      },
      hasFilter (type) {
        return this.$store.getters.getUseSexType.indexOf(type) > -1
      }
    },
    computed: {

    }
  }
</script>


<style scoped lang="less">
  @import "../../assets/css/palette";

  .gender-filter {
    li {
      margin: 1rem 0;
      button {
        display: block;
        /*padding: 1rem;*/
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 4.65rem;
        font-weight: bold;
        color: @brown-grey;
        box-sizing: border-box;
        border: 1px solid @very-light-pink-two;
        background-color: @white;

        &.on {
          background-color: @windows-blue;
          color: @white;
          border-color: @windows-blue;
        }
      }

      &:first-child {
        margin: 0 0 1rem 0;
      }

      &:last-child {
        margin: 1rem 0 0 0;
      }
    }
  }
</style>
